import { render } from "./StartProductTypeButtonList.vue?vue&type=template&id=ad5426d0&scoped=true"
import script from "./StartProductTypeButtonList.vue?vue&type=script&lang=js"
export * from "./StartProductTypeButtonList.vue?vue&type=script&lang=js"

import "./StartProductTypeButtonList.vue?vue&type=style&index=0&id=ad5426d0&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5426d0"]])

export default __exports__